/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Attr_AnonymousInputs */



/**
* | output |
* | --- |
* | "Anonymous" |
*
* @param {Deck_Upload_Attr_AnonymousInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_attr_anonymous = /** @type {((inputs?: Deck_Upload_Attr_AnonymousInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Attr_AnonymousInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Anonyme")
	if (locale === "es") return /** @type {LocalizedString} */ ("Anónimo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Anônimo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anonimo")
	return /** @type {LocalizedString} */ ("Anonymous")
});